export const namespaced = true

export const state = {
  isMovingForward: true,
  backButtonText: '',
  nextButtonText: '',
  transition: 'none',
  showBackButton: false,
  showNextButton: false,
  breadcrumbs: [],
  states: [],
  changeTypes: [],
  entityTypes: [],
  officerTitles: [],
  showConfirmLeaveModal: false,
  submissionStatuses: [
    { ID: 1, status: 'Not submitted' },
    { ID: 2, status: 'Submitted' }, 
    { ID: 3, status: 'Returned' },
    { ID: 4, status: 'Submitted to Spectrum' }
  ]
}

export const mutations = {
  SET_DIRECTION(state, isForward) {
    state.isMovingForward = isForward
  },
  SET_BACK_BUTTON_TEXT(state, text) {
    state.backButtonText = text
  },
  SET_NEXT_BUTTON_TEXT(state, text) {
    state.nextButtonText = text
  },
  SET_TRANSITION(state, transition) {
    state.transition = transition
  },
  SET_SHOW_BACK_BUTTON(state, show) {
    state.showBackButton = show
  },
  SET_SHOW_NEXT_BUTTON(state, show) {
    state.showNextButton = show
  },
  SET_BREADCRUMBS(state, breadcrumbs) {
    state.breadcrumbs = breadcrumbs
  },
  SET_STATES(state, states) {
    state.states = states
  },
  SET_CHANGE_TYPES(state, changeTypes) {
    state.changeTypes = changeTypes
  },
  SET_ENTITY_TYPES(state, entityTypes) {
    state.entityTypes = entityTypes
  },
  SET_OFFICER_TITLES(state, officerTitles) {
    state.officerTitles = officerTitles
  },
  SET_SHOW_CONFIRM_LEAVE_MODAL(state, show) {
    state.showConfirmLeaveModal = show
  }
}

export const actions = {
  setDirection({ commit }, isForward) {
    return new Promise(resolve => {
      commit('SET_DIRECTION', isForward)
      resolve()
    })
  },
  setBackButtonText({ commit }, text) {
    return new Promise(resolve => {
      commit('SET_BACK_BUTTON_TEXT', text)
      resolve()
    })
  },
  setNextButtonText({ commit }, text) {
    return new Promise(resolve => {
      commit('SET_NEXT_BUTTON_TEXT', text)
      resolve()
    })
  },
  setTransition({ commit }, transition) {
    return new Promise(resolve => {
      commit('SET_TRANSITION', transition)
      resolve()
    })
  },
  setButtonData({ commit }, data) {
    return new Promise(resolve => {
      commit('SET_SHOW_BACK_BUTTON', data.showBackButton)
      commit('SET_SHOW_NEXT_BUTTON', data.showNextButton)
      commit('SET_BACK_BUTTON_TEXT', data.backButtonText)
      commit('SET_NEXT_BUTTON_TEXT', data.nextButtonText)
      resolve()
    })
  },
  setBreadcrumbs({ commit }, breadcrumbs) {
    return new Promise(resolve => {
      commit('SET_BREADCRUMBS', breadcrumbs)
      resolve()
    })
  },
  setStates({ commit }, states) {
    return new Promise(resolve => {
      commit('SET_STATES', states)
      resolve()
    })
  },
  setChangeTypes({ commit }, changeTypes) {
    return new Promise(resolve => {
      commit('SET_CHANGE_TYPES', changeTypes)
      resolve()
    })
  },
  setEntityTypes({ commit }, entityTypes) {
    return new Promise(resolve => {
      commit('SET_ENTITY_TYPES', entityTypes)
      resolve()
    })
  },
  setOfficerTitles({ commit }, titles) {
    return new Promise(resolve => {
      commit('SET_OFFICER_TITLES', titles)
      resolve()
    })
  },
  openConfirmLeaveModal({ commit }) {
    return new Promise(resolve => {
      commit('SET_SHOW_CONFIRM_LEAVE_MODAL', true)
      resolve()
    })
  },
  closeConfirmLeaveModal({ commit }) {
    return new Promise(resolve => {
      commit('SET_SHOW_CONFIRM_LEAVE_MODAL', false)
      resolve()
    })
  }
}

export const getters = {
  submittedStatusID: state => state.submissionStatuses.find(s => s.status == 'Submitted').ID,
  notSubmittedStatusID: state => state.submissionStatuses.find(s => s.status == 'Not submitted').ID,
  returnedStatusID: state => state.submissionStatuses.find(s => s.status == 'Returned').ID,
  submittedToSpectrumStatusID: state => state.submissionStatuses.find(s => s.status == 'Submitted to Spectrum').ID,
  isSubmissionViewOnly: (state, getters, rootState, rootGetters) => rootGetters['user/isDCOUser'] || (rootState.submission.submission && (rootState.submission.submission.statusID == getters.submittedStatusID ||rootState.submission.submission.statusID == getters.submittedToSpectrumStatusID)),
  isChangeViewOnly: (state, getters, rootState, rootGetters) => rootGetters['user/isDCOUser'] || (rootState.change.change && rootState.change.change.submitted) || (rootState.submission.submission && rootState.submission.submission.statusID == getters.submittedStatusID),
  isChangeByChangeIdViewOnly: (state, getters, rootState, rootGetters) => changeID => {
    const change = rootGetters['change/changeById'](changeID)
    const submission = rootState.submission.submission
    return rootGetters['user/isDCOUser'] || (change && change.submitted) || (submission && submission.statusID == getters.submittedStatusID)
  }
}